<template>
<a-modal
    :title="viewTitle"
    visible
    @ok="save"
    @cancel="cancel"
  >
    <ak-inputs v-model="addData.data1" :options="addOptions.options1" ref="input1" />
    <ak-inputs v-model="addData.data2" :options="addOptions.options2" ref="input2" />
    <ak-inputs v-model="addData.data3" :options="addOptions.options3" ref="input3" />
</a-modal>
</template>
<script>
import { tkParse, tkRegions } from '@moke/vue-tk'
const reg = /^1[3456789]\d{9}$/
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object
  },
  data () {
    return {
      addData: {
        data1: { secondImg: [] },
        data2: {},
        data3: {}
      },
      viewTitle: '添加二手交易',
      addOptions: {
        options1: [
          {
            name: 'secondTitle', // 表单字段名，必填，用来分辨不同的input
            note: '二手物品名称', // 表单显示的名称，如果为空则显示表单name
            type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ]
          },
          {
            name: 'secondImg', // 表单字段名，必填，用来分辨不同的input
            note: '用户上传参考图片', // 表单显示的名称，如果为空则显示表单name
            type: 'Array', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            items: {
              type: 'Image'
            }
          },
          {
            name: 'deelType', // 表单字段名，必填，用来分辨不同的input
            note: '交易类型', // 表单显示的名称，如果为空则显示表单name
            type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ],
            items: {
              buy: '求购',
              sell: '出售'
            }
          },
          {
            name: 'secondClassify', // 表单字段名，必填，用来分辨不同的input
            note: '二手物品分类', // 表单显示的名称，如果为空则显示表单name
            type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ],
            items: {
              tool: '装修工具',
              building: '装修建材',
              more: '其他类型'
            }
          }
        ],
        options2: [
          {
            name: 'address', // 表单字段名，必填，用来分辨不同的input
            note: '地址', // 表单显示的名称，如果为空则显示表单name
            type: 'Region', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ]
          }
        ],
        options3: [
          {
            name: 'price', // 表单字段名，必填，用来分辨不同的input
            note: '价格', // 表单显示的名称，如果为空则显示表单name
            type: 'Number', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val > 0 ? null : '请输入大于0的价格'
            ]
          },
          {
            name: 'user', // 表单字段名，必填，用来分辨不同的input
            note: '发布用户', // 表单显示的名称，如果为空则显示表单name
            type: 'Pointer', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            targetClass: '_User', // 当数据类型为Pointer时必填，指定查询对象
            searchKey: ['wechatName'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
            listWhere: (where) => {
              where.authority = { $ne: 'administrator' }
            }, // 设置可选项的查询条件
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ]
          },
          {
            name: 'phone', // 表单字段名，必填，用来分辨不同的input
            note: '联系电话', // 表单显示的名称，如果为空则显示表单name
            type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => (val && !reg.test(val)) ? '请输入正确格式联系电话' : null
            ]
          }, {
            name: 'weChatNumber',
            note: '联系微信'
          },
          {
            name: 'mailbox',
            note: '联系邮箱'
          }
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    async save () {
      let erros1 = await this.$refs.input1.validate()
      let erros2 = await this.$refs.input2.validate()
      let erros3 = await this.$refs.input3.validate()
      if (Object.keys(erros1).length) return // 如果有错误，中断执行，不需要提示（inputs本身具有提示）
      if (Object.keys(erros2).length) return // 如果有错误，中断执行，不需要提示（inputs本身具有提示
      if (Object.keys(erros3).length) return // 如果有错误，中断执行，不需要提示（inputs本身具有提示
      try {
        // 获取用户的openId
        const res = await tkParse.get('/classes/_User', {
          params: {
            include: ['user'],
            where: {
              objectId: this.addData.data3.user
            }
          }
        })
        let address = tkRegions.getFullName(this.addData.data2.address).split(' ')
        await tkParse.post(`/classes/secondHand`, {
          secondTitle: this.addData.data1.secondTitle,
          secondImg: this.addData.data1.secondImg,
          deelType: this.addData.data1.deelType,
          secondClassify: this.addData.data1.secondClassify,
          address: address[0] + '·' + address[1] + '·' + address[2],
          region: address,
          price: this.addData.data3.price,
          user: this.addData.data3.user,
          phone: this.addData.data3.phone || '',
          weChatNumber: this.addData.data3.weChatNumber || '',
          mailbox: this.addData.data3.mailbox || '',
          openId: res.data.results[0].openId,
          isDelete: false
        })
        this.$notification['success']({
          message: '操作成功',
          description: '成功发布二手交易信息'
        })
        this.vm.refresh()
        this.$emit('complete', 'cancel')
      } catch (e) {
        this.$notification['error']({
          message: '失败',
          description: '创建二手交易失败, 请重试!'
        })
      }
    },
    cancel () {
      this.$emit('complete', 'cancel')
    }
  }
}
</script>
